(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lisse-buybox-controls"] && !Shopify.designMode) return;
  try {
    (function () {
    // Controller for every purchase selector on the page, scoped PER PRODUCT.
    //
    // On a product page there is one product in two places (hero + sticky bar):
    // both are unscoped, both land in the default group, and choosing in either
    // place re-renders the other — the original behaviour, unchanged.
    //
    // On a page listing SEVERAL products (the homepage product band) each buy
    // box is wrapped in `[data-buy-scope="<product id>"]`. Without that grouping
    // this controller wrote the first box's variant id into EVERY add-to-cart
    // form on the page, so choosing an option on one product would have posted
    // a different product to the cart.
    if (window.__lisseBuyboxBound) return;
    window.__lisseBuyboxBound = true;

    var DEFAULT_GROUP = '__page__';
    var states = {};

    // An element belongs to the nearest scope wrapper above it, or to the page.
    function groupOf(el) {
      var scope = el.closest ? el.closest('[data-buy-scope]') : null;
      return scope ? scope.getAttribute('data-buy-scope') : DEFAULT_GROUP;
    }

    function inGroup(selector, group) {
      var out = [];
      document.querySelectorAll(selector).forEach(function (el) {
        if (groupOf(el) === group) out.push(el);
      });
      return out;
    }

    function readData(b) {
      var group = groupOf(b);
      if (states[group]) return group;
      states[group] = {
        variantId: b.dataset.variant || null,
        plan: b.dataset.plan || '',
        onetime: b.dataset.onetime || '',
        sub: b.dataset.sub || '',
        mode: b.dataset.mode || (b.dataset.sub ? 'subscribe' : 'onetime')
      };
      return group;
    }

    function render(group) {
      var state = states[group];
      if (!state) return;
      var price = (state.mode === 'subscribe' && state.sub) ? state.sub : state.onetime;
      var plan = (state.mode === 'subscribe' && state.sub) ? state.plan : '';

      inGroup('[data-buybox-controls]', group).forEach(function (b) {
        b.setAttribute('data-mode', state.mode);
        b.querySelectorAll('[data-mode-card]').forEach(function (card) {
          var sel = card.getAttribute('data-mode-card') === state.mode;
          card.classList.toggle('is-selected', sel);
          var input = card.querySelector('input');
          if (input && input.checked !== sel) input.checked = sel;
        });
      });

      inGroup('[data-buy-cta]', group).forEach(function (el) { el.setAttribute('data-mode', state.mode); });
      inGroup('[data-buy-price]', group).forEach(function (el) { el.textContent = price; });
      inGroup('[data-buy-cta-total]', group).forEach(function (el) { el.textContent = price; });
      inGroup('[data-variant-input]', group).forEach(function (el) { el.value = state.variantId || ''; });
      // One-time: disable the field so no (empty) selling_plan is submitted.
      inGroup('[data-selling-plan-input]', group).forEach(function (el) {
        if (plan) {
          el.value = plan;
          el.disabled = false;
        } else {
          el.value = '';
          el.disabled = true;
        }
      });

      document.dispatchEvent(new CustomEvent('lisse:buy-change', {
        detail: { group: group, variantId: state.variantId, mode: state.mode, sellingPlan: plan, price: price }
      }));
    }

    function onChange(e) {
      if (!e.target || !e.target.closest) return;
      var card = e.target.closest('[data-mode-card]');
      if (!card) return;
      var b = card.closest('[data-buybox-controls]');
      if (!b) return;
      var group = groupOf(b);
      var state = states[group];
      if (!state) return;
      var m = card.getAttribute('data-mode-card');
      if (m === state.mode) return;
      state.mode = m;
      render(group);
    }

    function init() {
      // Re-read on every init so a section reloaded in the theme editor re-seeds.
      states = {};
      document.querySelectorAll('[data-buybox-controls]').forEach(function (b) {
        render(readData(b));
      });
    }

    document.addEventListener('change', onChange);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
